import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { IReportBoundaries } from "./report-boundaries.types";
import { BaseRespone } from "app/core/models/common.response";
import { environment } from "environments/environment";
import { catchError, map, switchMap, take, tap } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class ReportBoundriesService {
    private _boundrie: BehaviorSubject<IReportBoundaries | null> = new BehaviorSubject(null);
    private _boundries: BehaviorSubject<IReportBoundaries[] | null> = new BehaviorSubject(null);

    constructor(private _httpClient: HttpClient) { }

    get boundrie$(): Observable<IReportBoundaries> {
        return this._boundrie.asObservable();
    }

    get boundries$(): Observable<IReportBoundaries[]> {
        return this._boundries.asObservable();
    }

    getBoundries(reportId: number, boudriesType: string): Observable<BaseRespone<IReportBoundaries[]>> {
        return this._httpClient.get<BaseRespone<IReportBoundaries[]>>(`${environment.baseUrl}/Report/${reportId}/${boudriesType}/Boundries`).pipe(
            tap((response) => {
                this._boundries.next(response.result);
            })
        );
    }

    createBoundire(boundrie: any): Observable<BaseRespone<IReportBoundaries>> {
        return this._httpClient.post<BaseRespone<IReportBoundaries>>(`${environment.baseUrl}/Report/Boundries`, boundrie)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((response) => {
                    // Return the new product
                    if (response.isSuccess) {
                        this._boundries.next([response.result]);

                    }
                    return response;
                })
            );
    }
}